module.exports = __webpack_public_path__ + "static/media/NegArrow.79c1e5f4.svg";